//import axios from 'axios'
import { apiInstance, apiCoreInstance } from './apiInstance'

export const postRequestAsync = async (apiEndPoint, body = {}, headers) => {
  try {
    const response = await apiInstance.post(apiEndPoint, body, { headers })
    if (response.status === 200 && response.data.success) {
      return response.data && response.data
    }
    throw response.data
  } catch (e) {
    if (e.response && e.response.data) {
      const error = {
        data: {},
        msg: e.response.data.message || 'Something went wrong !',
      }
      throw error
    }
    if (!e.message && !e.msg) {
      e.data = {}
      e.msg = 'Something went wrong !'
      throw e
    } else {
      e.msg = e.message || e.msg
    }
    throw e
  }
}

export const postCoreRequestAsync = async (apiEndPoint, body = {}, headers) => {
  try {
    const response = await apiCoreInstance.post(apiEndPoint, body, { headers })
    if (response.status === 200 && response.data.success) {
      return response.data && response.data
    }
    throw response.data
  } catch (e) {
    if (e.response && e.response.data) {
      const error = {
        data: {},
        msg: e.response.data.message || 'Something went wrong !',
      }
      throw error
    }
    if (!e.message && !e.msg) {
      e.data = {}
      e.msg = 'Something went wrong !'
      throw e
    } else {
      e.msg = e.message || e.msg
    }
    throw e
  }
}